import * as messages from "@core/constants/messages";

type Params = Record<string, string | number>;

/**
 * 깊은 객체에서 'a.b.c' 형태의 문자열 키 union 타입 생성
 */
type Join<K, P> = K extends string | number ? (P extends string | number ? `${K}.${P}` : never) : never;

export type MessageKeys<T> = {
  [K in keyof T]: T[K] extends string ? K : T[K] extends Record<string, any> ? Join<K, MessageKeys<T[K]>> : never;
}[keyof T];

function getMessage(key: string, params?: Params): string {
  const parts = key.split(".");
  let msg: any = messages;

  for (const part of parts) {
    msg = msg?.[part];
    if (msg === undefined) return key; // fallback
  }

  if (typeof msg !== "string") return key;

  if (params) {
    Object.entries(params).forEach(([k, v]) => {
      msg = msg.replaceAll(`{${k}}`, String(v));
    });
  }

  return msg;
}

export function useMessage() {
  return (key: MessageKeys<typeof messages>, params?: Params) => getMessage(key, params);
}
